<!-- ================阅读拓展馆-博雅大语文====================-->
<template>
    <div class="read-bydyw-container">
        <home-head />
        <div class="read-bydyw-body">
            <div class="read-bydyw-inner" v-loading="loading">
                <!-- 标题区 -->
                <div class="read-bydyw-header">
                    <div class="read-bydyw-title-box">
                        <div class="read-bydyw-title">博雅大语文</div>
                        <div class="read-bydyw-subtitle">1-6年级语文逐课拓展阅读资源</div>
                    </div>
                    <div class="back-btn" @click="goBack">
                        <span class="back-arrow">←</span>
                        <span>返回</span>
                    </div>
                </div>

                <!-- 筛选栏 -->
                <div class="read-bydyw-filter">
                    <div class="filter-left">
                        <!-- <div class="filter-item">
                            <span class="filter-label">学段</span>
                            <el-select class="filter-select" v-model="queryParams.periodKey" clearable placeholder="请选择" @change="changePeriod">
                                <el-option v-for="item in periodList" :key="item.dictKey" :label="item.dictValue" :value="item.dictKey" />
                            </el-select>
                        </div> -->
                        <div class="filter-item">
                            <span class="filter-label">年级</span>
                            <el-select class="filter-select" v-model="queryParams.gradeKey" clearable placeholder="请选择" @change="changeGrade">
                                <el-option v-for="item in gradeList" :key="item.dictKey" :label="item.dictValue" :value="item.dictKey" />
                            </el-select>
                        </div>
                    </div>
                    <div class="filter-right">
                        <input class="search-input" type="text" v-model="queryParams.className" placeholder="请输入关键词" @keyup.enter="handleSearch" />
                        <div class="search-btn" @click="handleSearch">搜索</div>
                    </div>
                </div>

                <!-- 卡片列表 -->
                <div class="read-bydyw-cards">
                    <div class="library-card cursor" v-for="(item, index) in filteredList" :key="index" @click="handleCardClick(item)">
                        <div class="card-cover">
                            <img :src="item.coverUrl" :alt="item.className" />
                        </div>
                        <div class="card-title" :title="item.className">{{ item.className }}</div>
                    </div>
                </div>

                <!-- 暂无数据 -->
                <div class="empty-state" v-if="!loading && filteredList.length === 0">
                    <div class="empty-icon">
                        <img src="@/assets/image/data_empty.png" alt="暂无数据" />
                    </div>
                    <div class="empty-text">暂无数据</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { listClassLibrary } from "@/api/admin/classLibrary";
import { queryDict } from "@/api/admin/dict";
import homeHead from "@/components/common/homeHead.vue";

export default {
    components: { homeHead },
    name: "readBydyw",
    data() {
        return {
            loading: false,
            subjectList: [],
            periodList: [],
            gradeList: [],
            libraryList: [],
            queryParams: {
                className: '',
                periodKey: '1',
                gradeKey: '',
                subjectKey: '21',
            },
        }
    },
    computed: {
        filteredList() {
            const keyword = (this.queryParams.className || '').trim();
            if (!keyword) return this.libraryList;
            return this.libraryList.filter(item => {
                const name = item.className || item.bookName || '';
                return name.includes(keyword);
            });
        }
    },
    watch: {},
    created() {
        this.handleQueryDict();
    },
    mounted() {},
    methods: {
        /* ===============查询字典===================== */
        handleQueryDict() {
            queryDict({ code: "lession_xd_nj_xk" }).then(res => {
                if (res.data.code === 1) {
                    this.periodList = res.data.data || [];
                    this.changePeriod();
                }
            });
        },
        changePeriod() {
            this.queryParams.gradeKey = '';
            this.gradeList = [];
            this.subjectList = [];
            this.periodList.forEach(j => {
                if (this.queryParams.periodKey === j.dictKey) {
                    this.gradeList = j.childrenList || [];
                }
            });
            this.changeGrade();
        },
        changeGrade() {
            this.queryParams.subjectKey = '';
            this.subjectList = [];
            this.periodList.forEach(e => {
                if (this.queryParams.periodKey === e.dictKey) {
                    (e.childrenList || []).forEach(j => {
                        if (this.queryParams.gradeKey === j.dictKey) {
                            this.subjectList = j.childrenList || [];
                        }
                    });
                }
            });
            // 默认选中语文（subjectKey: 21）或第一个学科
            const chinese = this.subjectList.find(s => s.dictKey === '21');
            this.queryParams.subjectKey = chinese ? chinese.dictKey : (this.subjectList[0] && this.subjectList[0].dictKey) || '21';
            this.queryLibraryList();
        },
        /* ===============查询列表===================== */
        queryLibraryList() {
            this.loading = true;
            listClassLibrary(this.queryParams).then(res => {
                if (res.data.code === 1) {
                    this.libraryList = res.data.data || [];
                } else {
                    this.$message.error(res.data.msg || "请求出错");
                }
                this.loading = false;
            }).catch(() => {
                this.loading = false;
            });
        },
        /* ===============搜索===================== */
        handleSearch() {
            // 前端关键词过滤已由计算属性处理
        },
        /* ===============跳转===================== */
        goBack() {
            this.$router.push("/museum/read");
        },
        handleCardClick(item) {
            const classId = item.classId || item.id || "";
            this.$router.push({
                path: "/museum/read/bydywInfo",
                query: { classId: classId }
            });
        }
    }
}
</script>

<style scoped>
.read-bydyw-container {
    width: 100%;
    height: 100vh;
    display: flex;
    flex-direction: column;
    overflow: hidden;
}

.read-bydyw-body {
    flex: 1;
    min-height: 0;
    width: 100%;
    background-color: #fdfcf8;
    display: flex;
    justify-content: center;
    align-items: flex-start;
    padding: 30px 0;
    box-sizing: border-box;
    overflow: hidden;
}

.read-bydyw-inner {
    width: 100%;
    max-width: 1200px;
    height: 100%;
    margin: 0 auto;
    padding: 0 20px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
}

/* 标题区 */
.read-bydyw-header {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 24px;
    flex-shrink: 0;
}

.read-bydyw-title-box {
    display: flex;
    flex-direction: column;
}

.read-bydyw-title {
    font-size: 20px;
    color: #b22222;
    font-weight: bold;
    font-family: sans-serif;
    letter-spacing: 2px;
    margin-bottom: 8px;
}

.read-bydyw-subtitle {
    font-size: 14px;
    color: #9ca3af;
    font-family: sans-serif;
    letter-spacing: 1px;
}

.back-btn {
    height: 34px;
    line-height: 34px;
    padding: 0 28px;
    background-color: #b22222;
    color: #ffffff;
    border-radius: 4px;
    font-size: 14px;
    font-family: sans-serif;
    cursor: pointer;
    display: flex;
    align-items: center;
    transition: all 0.2s ease;
    flex-shrink: 0;
}

.back-btn:hover {
    background-color: #9a1b1b;
}

.back-arrow {
    margin-right: 8px;
    font-size: 16px;
}

/* 筛选栏 */
.read-bydyw-filter {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 24px;
    flex-shrink: 0;
}

.filter-left {
    display: flex;
    align-items: center;
    gap: 24px;
}

.filter-item {
    display: flex;
    align-items: center;
    gap: 10px;
}

.filter-label {
    font-size: 15px;
    color: #4b5563;
    font-family: sans-serif;
}

.filter-select {
    width: 120px !important;
}

.filter-select .el-select__wrapper {
    min-height: 34px !important;
    height: 34px;
    line-height: 34px;
    font-size: 14px;
}

.filter-right {
    display: flex;
    align-items: center;
    gap: 10px;
}

.search-input {
    width: 200px;
    height: 34px;
    line-height: 34px;
    padding: 0 12px;
    border: 1px solid #d1d5db;
    border-radius: 4px;
    outline: none;
    font-size: 14px;
    font-family: sans-serif;
    box-sizing: border-box;
    background-color: #ffffff;
}

.search-input:focus {
    border-color: #b22222;
}

.search-btn {
    height: 34px;
    line-height: 34px;
    padding: 0 20px;
    border: 1px solid #b22222;
    border-radius: 4px;
    font-size: 14px;
    color: #b22222;
    background-color: #ffffff;
    font-family: sans-serif;
    cursor: pointer;
    transition: all 0.2s ease;
    box-sizing: border-box;
}

.search-btn:hover {
    background-color: #b22222;
    color: #ffffff;
}

/* 卡片列表 */
.read-bydyw-cards {
    width: 100%;
    flex: 1;
    min-height: 0;
    display: flex;
    flex-wrap: wrap;
    gap: 20px;
    box-sizing: border-box;
    overflow-y: auto;
    align-content: flex-start;
    padding-bottom: 20px;
    padding-top: 10px;
}
.read-bydyw-cards::-webkit-scrollbar {
    width: 10px;
    height: 10px;
}
.read-bydyw-cards::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 6px;
}
.read-bydyw-cards::-webkit-scrollbar-thumb {
    background: #b22222;
    border-radius: 6px;
    border: 3px solid #f1f1f1;
}
.read-bydyw-cards::-webkit-scrollbar-thumb:hover {
    background: #555;
}
.library-card {
    width: calc(16.666% - 16.667px);
    flex-shrink: 0;
    background-color: #ffffff;
    border: 1.5px solid #b22222;
    border-radius: 4px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    cursor: pointer;
    transition: all 0.25s ease;
    overflow: hidden;
}

.library-card:hover {
    transform: translateY(-4px);
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);
}

.card-cover {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #f3f4f6;
}

.card-cover img {
    width: 100%;
    height: auto;
    object-fit: contain;
    display: block;
}

.card-title {
    width: 100%;
    min-height: 42px;
    line-height: 20px;
    padding: 8px 10px;
    font-size: 14px;
    color: #1f2937;
    font-family: sans-serif;
    text-align: center;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    box-sizing: border-box;
}

/* 暂无数据 */
.empty-state {
    width: 100%;
    flex: 1;
    min-height: 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    box-sizing: border-box;
}

.empty-icon {
    width: 100px;
    height: 100px;
    margin-bottom: 12px;
}

.empty-icon img {
    width: 100%;
    width: 100%;
    object-fit: contain;
}

.empty-text {
    font-size: 15px;
    color: #9ca3af;
    font-family: sans-serif;
    letter-spacing: 1px;
}

@media (max-width: 1024px) {
    .library-card { width: calc(25% - 15px); }
}

@media (max-width: 768px) {
    .read-bydyw-header { flex-direction: column; align-items: flex-start; gap: 12px; }
    .read-bydyw-filter { flex-direction: column; align-items: flex-start; gap: 12px; }
    .filter-left { width: 100%; gap: 12px; }
    .filter-right { width: 100%; }
    .search-input { flex: 1; }
    .library-card { width: calc(50% - 10px); }

}
</style>
